/**
 * Generato automaticamente.
 * framework-cmp-domande
 */

export type EnumOnereWithDettaglioDTOStato =
  (typeof EnumOnereWithDettaglioDTOStato)[keyof typeof EnumOnereWithDettaglioDTOStato];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnumOnereWithDettaglioDTOStato = {
  ATTESA_PAGAMENTO: 'ATTESA_PAGAMENTO',
  DA_PAGARE: 'DA_PAGARE',
  RICHIESTA_INTEGRAZIONE_PAGAMENTO: 'RICHIESTA_INTEGRAZIONE_PAGAMENTO',
  PAGATO: 'PAGATO',
} as const;
